module.exports = __webpack_public_path__ + "static/img/hh.678313dc.png";